export default __webpack_public_path__ + "static/media/testi.1fb988e3.svg";